module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aso-upload-face-card",
    class: {
      'aso-upload-face-card--disabled': _vm.disabled
    }
  }, [(_vm.label) ? _c('p', {
    staticClass: "aso-upload-face-card__label"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "triggerRef",
    staticClass: "aso-upload-face-card__trigger"
  }, [_c('button', {
    staticClass: "aso-upload-face-card__visual",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled || _vm.busy
    },
    on: {
      "click": _vm.tryOpenLiveCamera
    }
  }, [(_vm.loading) ? _c('span', {
    staticClass: "aso-upload-face-card__loader"
  }, [_vm._v("Falta pouco...")]) : (_vm.uploaded) ? _c('span', {
    staticClass: "aso-upload-face-card__status aso-upload-face-card__status--success"
  }, [_vm._v("✓ Foto validada")]) : (_vm.hasError) ? _c('span', {
    staticClass: "aso-upload-face-card__status aso-upload-face-card__status--error"
  }, [_vm._v("⚠ Falha no upload")]) : _c('span', {
    staticClass: "aso-upload-face-card__status"
  }, [_vm._v("Toque para tirar foto")])])]), _vm._v(" "), (_vm.cameraError && !_vm.isWebcamOpen) ? _c('p', {
    staticClass: "aso-upload-face-card__camera-error aso-upload-face-card__camera-error--inline"
  }, [_vm._v("\n    " + _vm._s(_vm.cameraError) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.isWebcamOpen) ? _c('div', {
    staticClass: "aso-upload-face-card__modal",
    class: _vm.capturedPhoto ? 'aso-upload-face-card__modal--preview' : 'aso-upload-face-card__modal--camera'
  }, [_c('div', {
    staticClass: "aso-upload-face-card__modal-content",
    class: _vm.capturedPhoto ? 'aso-upload-face-card__modal-content--preview' : 'aso-upload-face-card__modal-content--camera'
  }, [_c('h3', {
    staticClass: "aso-upload-face-card__modal-title"
  }, [_vm._v(_vm._s(_vm.capturedPhoto ? 'Confirme sua foto' : 'Tire sua foto'))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.capturedPhoto),
      expression: "capturedPhoto"
    }],
    staticClass: "aso-upload-face-card__preview-container"
  }, [_c('img', {
    staticClass: "aso-upload-face-card__preview-full",
    attrs: {
      "src": _vm.capturedPhoto
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.capturedPhoto),
      expression: "!capturedPhoto"
    }],
    staticClass: "aso-upload-face-card__media-container"
  }, [_c('video', {
    ref: "videoElement",
    staticClass: "aso-upload-face-card__video",
    attrs: {
      "autoplay": "",
      "playsinline": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "aso-upload-face-card__modal-actions",
    class: _vm.capturedPhoto ? 'aso-upload-face-card__modal-actions--preview' : 'aso-upload-face-card__modal-actions--camera'
  }, [(_vm.capturedPhoto) ? _c('button', {
    staticClass: "aso-upload-face-card__modal-btn aso-upload-face-card__modal-btn--primary",
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.confirmPhoto
    }
  }, [_vm._v("\n          Confirmar e enviar\n        ")]) : _c('button', {
    staticClass: "aso-upload-face-card__modal-btn aso-upload-face-card__modal-btn--primary",
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.captureFrame
    }
  }, [_vm._v("\n          Tirar foto\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "aso-upload-face-card__modal-btn aso-upload-face-card__modal-btn--danger",
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": function($event) {
        _vm.capturedPhoto ? _vm.resetCapture() : _vm.closeLiveCamera()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.capturedPhoto ? 'Tirar outra foto' : 'Cancelar') + "\n        ")])]), _vm._v(" "), (_vm.cameraError && !_vm.capturedPhoto) ? _c('p', {
    staticClass: "aso-upload-face-card__camera-error"
  }, [_vm._v(_vm._s(_vm.cameraError))]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21b13180"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/funcionario/aso/assinar/UploadFaceCard.vue
// module id = 1433
// module chunks = 45